import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import MasterNavbar from '../../components/layout/MasterNavbar';
import Footer from '../../components/layout/Footer';

function MasterDashboard() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/master-login');
      return;
    }

    try {
      const decoded = JSON.parse(atob(token)); // ✅ decode PHP-style token
      setUser(decoded);
    } catch (err) {
      console.error('Invalid token:', err);
      localStorage.removeItem('token');
      navigate('/master-login');
    }
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/master-login');
  };

  if (!user) return <div className="text-center mt-5">Loading user info...</div>;

  return (
    <>
      <MasterNavbar />
      <div className="container mt-5">
        <div className="card shadow p-4">
          <h2 className="text-center mb-4">Welcome, {user.mobile}</h2>
          <div className="d-flex justify-content-between">
            <div>
              <p><strong>Mobile:</strong> {user.mobile}</p>
              <p><strong>User ID:</strong> {user.id}</p>
              <p><strong>Logged in at:</strong> {new Date(user.timestamp * 1000).toLocaleString()}</p>
            </div>
            <button className="btn btn-danger" onClick={handleLogout}>Logout</button>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default MasterDashboard;
